import React, { useState } from 'react';
import { LeafIcon } from 'lucide-react';
import { Modal } from './Modal';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const close = () => setActiveModal(null);
  return <>
      <footer className="w-full bg-beige border-t border-blush/30 py-12" data-id="element-52">
        <div className="max-w-6xl mx-auto px-6 md:px-8" data-id="element-53">
          <div className="text-center space-y-6" data-id="element-54">
            <div className="inline-flex items-center gap-2" data-id="element-55">
              <LeafIcon className="w-5 h-5 text-sage-deep" data-id="element-56" />
              <h3 className="font-serif text-2xl text-ink" data-id="element-57">
                El Detox Invisible
              </h3>
            </div>

            <p className="text-ink-soft text-sm max-w-2xl mx-auto leading-relaxed" data-id="element-58">
              Este producto no sustituye consejo médico profesional. Consulta
              con tu médico antes de hacer cambios significativos en tu estilo
              de vida, especialmente si estás bajo tratamiento de fertilidad.
            </p>

            <nav className="flex flex-wrap items-center justify-center gap-x-2 gap-y-2 pt-2" data-id="element-59">
              <button onClick={() => setActiveModal('privacy')} className="text-ink-soft hover:text-sage-deep underline-offset-4 hover:underline transition-colors duration-200 text-sm font-medium px-3 py-1" data-id="element-60">
                Política de Privacidad
              </button>
              <span className="text-ink-muted" aria-hidden="true" data-id="element-61">
                ·
              </span>
              <button onClick={() => setActiveModal('terms')} className="text-ink-soft hover:text-sage-deep underline-offset-4 hover:underline transition-colors duration-200 text-sm font-medium px-3 py-1" data-id="element-62">
                Términos y Condiciones
              </button>
            </nav>

            <div className="pt-4 border-t border-blush/30 max-w-md mx-auto" data-id="element-63">
              <p className="text-ink-muted text-sm" data-id="element-64">
                © 2026 El Detox Invisible. Todos los derechos reservados.
              </p>
            </div>
          </div>
        </div>
      </footer>

      <Modal isOpen={activeModal === 'privacy'} onClose={close} title="Política de Privacidad" data-id="element-65">
        <div className="space-y-5 text-sm md:text-base" data-id="element-66">
          <p className="text-ink-muted text-xs uppercase tracking-widest" data-id="element-67">
            Última actualización: Enero 2026
          </p>

          <section data-id="element-68">
            <h3 className="font-serif text-lg text-ink mb-2" data-id="element-69">
              1. Información que recopilamos
            </h3>
            <p data-id="element-70">
              En El Detox Invisible recopilamos únicamente la información
              necesaria para procesar tu compra y entregarte el material:
              nombre, correo electrónico y datos de pago (procesados de forma
              segura por nuestros proveedores con encriptación SSL).
            </p>
          </section>

          <section data-id="element-71">
            <h3 className="font-serif text-lg text-ink mb-2" data-id="element-72">
              2. Uso de tu información
            </h3>
            <p data-id="element-73">
              Utilizamos tu correo electrónico exclusivamente para enviarte el
              acceso a la guía, actualizaciones del protocolo y, ocasionalmente,
              contenido educativo relacionado. Nunca vendemos ni compartimos tus
              datos con terceros.
            </p>
          </section>

          <section data-id="element-74">
            <h3 className="font-serif text-lg text-ink mb-2" data-id="element-75">3. Cookies</h3>
            <p data-id="element-76">
              Este sitio utiliza cookies básicas para analítica y para mejorar
              tu experiencia de navegación. Puedes deshabilitarlas desde la
              configuración de tu navegador en cualquier momento.
            </p>
          </section>

          <section data-id="element-77">
            <h3 className="font-serif text-lg text-ink mb-2" data-id="element-78">
              4. Tus derechos
            </h3>
            <p data-id="element-79">
              Tienes derecho a acceder, modificar o eliminar tus datos
              personales en cualquier momento. Procesaremos cualquier solicitud
              relacionada con tus datos en un plazo máximo de 14 días.
            </p>
          </section>

          <section data-id="element-80">
            <h3 className="font-serif text-lg text-ink mb-2" data-id="element-81">5. Seguridad</h3>
            <p data-id="element-82">
              Todos los datos se almacenan en servidores seguros con protocolos
              de cifrado actualizados. Los pagos son procesados por plataformas
              certificadas PCI-DSS.
            </p>
          </section>
        </div>
      </Modal>

      <Modal isOpen={activeModal === 'terms'} onClose={close} title="Términos y Condiciones" data-id="element-83">
        <div className="space-y-5 text-sm md:text-base" data-id="element-84">
          <p className="text-ink-muted text-xs uppercase tracking-widest" data-id="element-85">
            Última actualización: Enero 2026
          </p>

          <section data-id="element-86">
            <h3 className="font-serif text-lg text-ink mb-2" data-id="element-87">
              1. Naturaleza del producto
            </h3>
            <p data-id="element-88">
              "El Detox Invisible" es un producto digital (PDF descargable y
              materiales complementarios) de carácter educativo e informativo.
              Al completar la compra recibirás acceso inmediato al material.
            </p>
          </section>

          <section data-id="element-89">
            <h3 className="font-serif text-lg text-ink mb-2" data-id="element-90">
              2. Aviso médico
            </h3>
            <p data-id="element-91">
              Este producto NO sustituye el consejo médico profesional. La
              información contenida es de carácter educativo. Antes de aplicar
              cualquier protocolo, especialmente si estás bajo tratamiento de
              fertilidad o tienes condiciones médicas preexistentes, consulta
              con tu médico.
            </p>
          </section>

          <section data-id="element-92">
            <h3 className="font-serif text-lg text-ink mb-2" data-id="element-93">
              3. Política de reembolso
            </h3>
            <p data-id="element-94">
              Ofrecemos una garantía de satisfacción de 7 días desde la fecha de
              compra. Si no estás satisfecho con el contenido dentro de ese
              plazo, procesaremos el reembolso completo.
            </p>
          </section>

          <section data-id="element-95">
            <h3 className="font-serif text-lg text-ink mb-2" data-id="element-96">
              4. Propiedad intelectual
            </h3>
            <p data-id="element-97">
              Todo el contenido es propiedad de El Detox Invisible. Está
              prohibida su reproducción, distribución o reventa sin autorización
              escrita. La licencia adquirida es personal e intransferible.
            </p>
          </section>

          <section data-id="element-98">
            <h3 className="font-serif text-lg text-ink mb-2" data-id="element-99">
              5. Limitación de responsabilidad
            </h3>
            <p data-id="element-100">
              Los resultados varían según cada persona. No garantizamos
              resultados específicos en términos de fertilidad. Al adquirir el
              producto, aceptas que cualquier decisión tomada con base en su
              contenido es de tu responsabilidad.
            </p>
          </section>

          <section data-id="element-101">
            <h3 className="font-serif text-lg text-ink mb-2" data-id="element-102">
              6. Modificaciones
            </h3>
            <p data-id="element-103">
              Nos reservamos el derecho de actualizar estos términos en
              cualquier momento. Te notificaremos cambios significativos por
              correo electrónico.
            </p>
          </section>
        </div>
      </Modal>
    </>;
}